var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 525,
    viewBox: "0 0 405 525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.149 9.65741C417.94 34.9588 403.109 116.97 379.552 171.935C355.123 226.028 323.715 253.947 328.077 308.912C332.439 364.749 373.445 448.505 360.358 489.511C348.144 529.644 280.964 527.027 218.147 520.92C156.202 514.812 97.7471 504.343 59.3588 472.062C20.9705 439.781 1.7764 385.688 0.0314725 335.958C-0.840989 286.228 16.6082 241.732 29.6952 194.619C43.6545 147.506 53.2516 97.776 82.9153 72.4746C113.451 48.0457 163.182 47.1732 225.127 31.4689C287.071 14.8922 360.358 -15.644 389.149 9.65741Z",
    fill: "url(#paint0_linear_62_597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_597",
    x1: 0,
    y1: 524.425,
    x2: 507.389,
    y2: 132.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA81F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob 3.695bdfc6024c2f5c6fe833c652e2cc12.svg";
export { ForwardRef as ReactComponent };